/*!
 * pkcs8.js - PKCS8 encoding for javascript
 * Copyright (c) 2018, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcrypto
 *
 * Parts of this software are based on golang/go:
 *   Copyright (c) 2009 The Go Authors. All rights reserved.
 *   https://github.com/golang/go
 *
 * Resources:
 *   https://github.com/golang/go/blob/master/src/crypto/x509/pkcs8.go
 *   https://tools.ietf.org/html/rfc5208
 */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var asn1 = require('./asn1');

var pem = require('./pem');

var x509 = require('./x509');
/**
 * PublicKeyInfo
 */
// PublicKeyInfo ::= SEQUENCE {
//   algorithm       AlgorithmIdentifier,
//   PublicKey       BIT STRING
// }


var PublicKeyInfo = /*#__PURE__*/function (_asn1$Sequence) {
  _inherits(PublicKeyInfo, _asn1$Sequence);

  var _super = _createSuper(PublicKeyInfo);

  function PublicKeyInfo(algorithm, identifier, publicKey) {
    var _this;

    _classCallCheck(this, PublicKeyInfo);

    _this = _super.call(this);
    _this.algorithm = new x509.AlgorithmIdentifier(algorithm, identifier);
    _this.publicKey = new asn1.BitString(publicKey);
    return _this;
  }

  _createClass(PublicKeyInfo, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.algorithm.getSize();
      size += this.publicKey.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.algorithm.write(bw);
      this.publicKey.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.algorithm.read(br);
      this.publicKey.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.algorithm.clean() && this.publicKey.clean();
    }
  }, {
    key: "toPEM",
    value: function toPEM() {
      return pem.toPEM(this.encode(), 'PUBLIC KEY');
    }
  }, {
    key: "fromPEM",
    value: function fromPEM(str) {
      var data = pem.fromPEM(str, 'PUBLIC KEY');
      return this.decode(data);
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        algorithm: this.algorithm,
        publicKey: this.publicKey
      };
    }
  }]);

  return PublicKeyInfo;
}(asn1.Sequence);
/**
 * PrivateKeyInfo
 */
// PrivateKeyInfo ::= SEQUENCE {
//   version         Version,
//   algorithm       AlgorithmIdentifier,
//   PrivateKey      OCTET STRING
// }
//
// PrivateKeyInfo ::= SEQUENCE {
//    version Version,
//    privateKeyAlgorithm AlgorithmIdentifier {{PrivateKeyAlgorithms}},
//    privateKey PrivateKey,
//    attributes [0] Attributes OPTIONAL
// }
//
// Version ::= INTEGER {v1(0)} (v1,...)
//
// PrivateKey ::= OCTET STRING


var PrivateKeyInfo = /*#__PURE__*/function (_asn1$Sequence2) {
  _inherits(PrivateKeyInfo, _asn1$Sequence2);

  var _super2 = _createSuper(PrivateKeyInfo);

  function PrivateKeyInfo(version, algorithm, parameters, privateKey) {
    var _this2;

    _classCallCheck(this, PrivateKeyInfo);

    _this2 = _super2.call(this);
    _this2.version = new asn1.Unsigned(version);
    _this2.algorithm = new x509.AlgorithmIdentifier(algorithm, parameters);
    _this2.privateKey = new asn1.OctString(privateKey);
    return _this2;
  }

  _createClass(PrivateKeyInfo, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.version.getSize();
      size += this.algorithm.getSize();
      size += this.privateKey.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.version.write(bw);
      this.algorithm.write(bw);
      this.privateKey.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.version.read(br);
      this.algorithm.read(br);
      this.privateKey.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.version.clean() && this.algorithm.clean() && this.privateKey.clean();
    }
  }, {
    key: "toPEM",
    value: function toPEM() {
      return pem.toPEM(this.encode(), 'PRIVATE KEY');
    }
  }, {
    key: "fromPEM",
    value: function fromPEM(str) {
      var data = pem.fromPEM(str, 'PRIVATE KEY');
      return this.decode(data);
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        version: this.version,
        algorithm: this.algorithm,
        privateKey: this.privateKey
      };
    }
  }, {
    key: "isRaw",
    get: function get() {
      return true;
    }
  }]);

  return PrivateKeyInfo;
}(asn1.Sequence);
/**
 * EncryptedPrivateKeyInfo
 */
// EncryptedPrivateKeyInfo ::= SEQUENCE {
//   encryptionAlgorithm  EncryptionAlgorithmIdentifier,
//   encryptedData        EncryptedData
// }
//
// EncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
//
// EncryptedData ::= OCTET STRING


var EncryptedPrivateKeyInfo = /*#__PURE__*/function (_asn1$Sequence3) {
  _inherits(EncryptedPrivateKeyInfo, _asn1$Sequence3);

  var _super3 = _createSuper(EncryptedPrivateKeyInfo);

  function EncryptedPrivateKeyInfo(algorithm, identifier, data) {
    var _this3;

    _classCallCheck(this, EncryptedPrivateKeyInfo);

    _this3 = _super3.call(this);
    _this3.algorithm = new x509.AlgorithmIdentifier(algorithm, identifier);
    _this3.data = new asn1.OctString(data);
    return _this3;
  }

  _createClass(EncryptedPrivateKeyInfo, [{
    key: "getBodySize",
    value: function getBodySize() {
      var size = 0;
      size += this.algorithm.getSize();
      size += this.data.getSize();
      return size;
    }
  }, {
    key: "writeBody",
    value: function writeBody(bw) {
      this.algorithm.write(bw);
      this.data.write(bw);
      return bw;
    }
  }, {
    key: "readBody",
    value: function readBody(br) {
      this.algorithm.read(br);
      this.data.read(br);
      return this;
    }
  }, {
    key: "clean",
    value: function clean() {
      return this.algorithm.clean() && this.data.clean();
    }
  }, {
    key: "toPEM",
    value: function toPEM() {
      return pem.toPEM(this.encode(), 'ENCRYPTED PRIVATE KEY');
    }
  }, {
    key: "fromPEM",
    value: function fromPEM(str) {
      var data = pem.fromPEM(str, 'ENCRYPTED PRIVATE KEY');
      return this.decode(data);
    }
  }, {
    key: "format",
    value: function format() {
      return {
        type: this.constructor.name,
        algorithm: this.algorithm,
        data: this.data
      };
    }
  }]);

  return EncryptedPrivateKeyInfo;
}(asn1.Sequence);
/*
 * Expose
 */


exports.PublicKeyInfo = PublicKeyInfo;
exports.PrivateKeyInfo = PrivateKeyInfo;
exports.EncryptedPrivateKeyInfo = EncryptedPrivateKeyInfo;